<template>
    <div
        :class="[
            'web-news-market-list',
            {
                isPC: !isH5
            }
        ]"
    >
        <div v-if="isPreRender" key="hideContent"></div>
        <div v-else-if="loading" class="loading">
            <img src="../images/loading.png" alt="loading..." />
        </div>
        <div v-else-if="showContent" key="showContent" class="content-wrapper">
            <div class="web-news-market-list-content">
                <a
                    v-for="(item, index) in showCountList"
                    :key="index"
                    class="item"
                    href="javascript:;"
                    @click="onClickItem(item)"
                >
                    <div class="title-source">
                        <div class="title" :style="{ color: titleColor }">{{ item.title }}</div>
                        <div class="source" :style="{ color: sourceColor }">
                            {{ item.source }}&nbsp;&nbsp;{{ formatTime(item.timestamp) }}
                        </div>
                    </div>
                    <div class="img-wrapper">
                        <img :src="item.pic" />
                    </div>
                </a>
            </div>
            <div class="btn" v-if="showBtn">
                <a
                    :class="[
                        'more-text',
                        {
                            isMoo: isMoo
                        }
                    ]"
                    :style="{
                        '--more-color': moreColor
                    }"
                    href="javascript:;"
                    @click="onClickMore"
                >
                    {{ moreText }}
                    <svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.25 2L9.75 9.5L2.25 17"
                            stroke-width="2"
                            stroke-linecap="square"
                            stroke-linejoin="round"
                        />
                    </svg>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
const {
    common: {
        request: { bindCommonApi },
        behavior: { runBehaviour }
    }
} = require('@futuweb/fego-render');

const commonApiRequest = bindCommonApi('web-news-market-list');
import { isH5, getIsPreRender, isMoo, getEntity } from '../utils';
import { LANG_NUM_MAP } from '../constants/i18n';
import { NN_NEWS_MARKET_LIST_URL, MM_NEWS_MARKET_LIST_URL } from '../constants/index';
import { ToolDateFormatter, TEMPLATE_YMD, TEMPLATE_HMS } from '@futuweb/tool-date-formatter';

const toolDateFormatter = new ToolDateFormatter({
    entity: getEntity()
});

export default {
    name: 'web-news-market-list',
    props: {
        language: {
            type: String,
            default: 'en-us'
        },
        titleColor: {
            type: String,
            default: '#262626'
        },
        sourceColor: {
            type: String,
            default: '#7a7a7a'
        },
        // 展示条数
        showCount: {
            type: Number,
            default: 3
        },
        // 查看更多
        moreText: {
            type: String,
            default: 'More'
        },
        moreColor: {
            type: String,
            default: '#327FFF'
        },
        needLogin: {
            type: Boolean,
            default: true
        },
        showBtn: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            loading: false,
            isH5: isH5(),
            isPreRender: getIsPreRender(),
            list: [],
            isMoo: isMoo()
        };
    },
    computed: {
        showContent() {
            return !this.loading && this.list && this.list.length;
        },
        showCountList() {
            return this.list.slice(0, this.showCount);
        }
    },
    async mounted() {
        if (this.isPreRender) {
            return;
        }
        this.loading = true;

        try {
            const data = await commonApiRequest.get(
                'list',
                {
                    lang: LANG_NUM_MAP[this.language],
                    size: this.showCount
                },
                {
                    group: null
                }
            );
            this.list = data && data.list;
        } catch (error) {
            this.list = []; // 不展示
        }

        this.loading = false;
    },
    methods: {
        formatTime(time) {
            return toolDateFormatter.dateFormatByTemplate({
                dateTemplateArr: [TEMPLATE_YMD.MONTH_DAY, TEMPLATE_HMS.HOUR_MINUTE],
                timestamps: time * 1e3,
                lang: LANG_NUM_MAP[this.language]
            });
        },
        onClickItem(item) {
            const url = item.url;
            if (this.needLogin) {
                return runBehaviour(this, {
                    type: 'login',
                    value: url,
                    lang: this.language,
                    withQuery: true
                });
            }
            return (location.href = url);
        },
        onClickMore() {
            const url = this.isMoo
                ? `${MM_NEWS_MARKET_LIST_URL}?lang=${this.language}`
                : `${NN_NEWS_MARKET_LIST_URL}?lang=${this.language}`;
            if (this.needLogin) {
                return runBehaviour(this, {
                    type: 'login',
                    value: url,
                    lang: this.language,
                    withQuery: true
                });
            }
            return (location.href = url);
        }
    }
};
</script>
<style lang="less" scoped>
.web-news-market-list {
    height: auto !important;
    &.ja {
        .web-news-market-list-content {
            .item {
                .title-source {
                    .title {
                        font-weight: 700;
                    }
                }
            }
        }
    }
    .web-news-market-list-content {
        padding: 0 0.4rem;
        .item {
            display: flex;
            align-items: center;
            padding: 0.3rem 0;
            position: relative;
            a {
                position: absolute;
                display: block;
                width: 100%;
                height: 100%;
            }
            &:first-child {
                padding-top: 0;
            }
            &:last-child {
                padding-bottom: 0;
            }
            &:not(:last-child) {
                border-bottom: 1px solid #e5e5e5;
            }
            .title-source {
                flex: 1;
                min-width: 0;
                margin-right: 0.3rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 1.4rem;
                .title {
                    font-size: 0.3rem;
                    line-height: 1.5;
                    // 限制两行
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }
                .source {
                    font-size: 0.22rem;
                }
            }
            .img-wrapper {
                width: 1.8rem;
                height: 1.4rem;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 0.06rem;
                    object-fit: cover;
                }
            }
        }
    }
    .content-wrapper {
        position: relative;
        .btn {
            display: flex;
            justify-content: center;
            margin-top: 0.4rem;
            .more-text {
                font-size: 0.3rem;
                line-height: 0.3rem;
                color: var(--more-color);
                display: flex;
                align-items: center;
                svg {
                    margin-left: 0.12rem;
                    width: 0.15rem;
                    height: 0.26rem;
                    path {
                        stroke: var(--more-color);
                    }
                }
            }
        }
    }
    .loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 2rem;
        @keyframes rotate {
            0% {
                transform: rotate(0);
            }
            100% {
                transform: rotate(360deg);
            }
        }
        img {
            width: 0.56rem;
            height: 0.56rem;
            background: url('../images/loading.png') center / contain no-repeat;
            animation: rotate 2s linear infinite;
        }
    }
}
.web-news-market-list.isPC {
    .content-wrapper {
        margin: auto;
        .btn {
            .more-text {
                font-size: 0.22rem;
            }
        }
    }
    .web-news-market-list-content {
        padding: 0;
        .item {
            cursor: pointer;
            .title-source {
                height: 1.6rem;
                margin-right: 0.4rem;
                .title {
                    font-size: 0.22rem;
                }
                .source {
                    font-size: 0.16rem;
                }
            }
            .img-wrapper {
                width: 2.4rem;
                height: 1.6rem;
            }
        }
    }
    .loading {
        height: 3rem;
    }
}
</style>
